/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Exclude_CnInputs */

const en_admin_funnel_exclude_cn = /** @type {(inputs: Admin_Funnel_Exclude_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclude CN/HK traffic`)
};

/**
* | output |
* | --- |
* | "Exclude CN/HK traffic" |
*
* @param {Admin_Funnel_Exclude_CnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_exclude_cn = /** @type {((inputs?: Admin_Funnel_Exclude_CnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Exclude_CnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_exclude_cn(inputs)
});
export { admin_funnel_exclude_cn as "admin.funnel.exclude_cn" }